<template lang="pug">
.card.mb-0
  .card-header
    .row.w-100      
      .form-group.col-md-3.col-2.mb-1
        b-input-group(size="sm")
          b-input-group-text(slot="prepend")
            i.fa.fa-search
          DebounceInput(autofocus type="text" v-model="search" :placeholder="$t('ui.campaign_id')" @enter="getCampaignList(true)" size="sm")
      .form-group.col-md-9.col-10.mb-1
        SubmitButton(
          :loading="loading"
          icon="fa fa-search"
          :text="$t('ui.search')"
          type="button"
          @click="getCampaignList(true)"
          variant="primary"
          size="sm"
        )
      .form-group.col-6.mb-1(v-if="isEditAccess")
        b-button(v-b-modal.addCampaign type="button" variant="info" size="sm")
          i.fa.fa-plus
          span.ml-1 {{ $t("ui.combine.add_campaign") }}
  .card-body
    .row
      .col-10.mb-1
        b-pagination.float-left(
          size="sm"
          hide-ellipsis
          :total-rows="totalRow"
          :per-page="getPageSize"
          v-model="currentPage"
          @input="changedPage($event)"
        )
      .col-2.mb-1
        b-input-group(:prepend="$t('ui.page_size')" size="sm")
          b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")              
      .col-12
        .clusterize-scroll.table-responsive
          table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
            thead.thead-light
              tr
                th.text-center(width="3%")
                  span #
                th.sortable(width="8%" @click="sortOrder('campaign_id')")
                  span(:title="$t('ui.campaign_id')") {{ $t('ui.campaign_id') }}
                  .float-right
                    i(:class="changeSortKey('campaign_id')")
                th.sortable(width="10%" @click="sortOrder('campaign_name')")
                  span(:title="$t('ui.campaign_name')") {{ $t('ui.campaign_name') }}
                  .float-right
                    i(:class="changeSortKey('campaign_name')")
                th.sortable(width="6%" @click="sortOrder('criteria')")
                  span(:title="$t('ui.criteria')") {{ $t('ui.short.criteria') }}
                  .float-right
                    i(:class="changeSortKey('criteria')")
                th.text-right.sortable(width="6%" @click="sortOrder('rollover')")
                  span(:title="$t('ui.rollover')") {{ $t("ui.short.rollover") }}
                  .float-right
                    i(:class="changeSortKey('rollover')")
                th.text-right.sortable(width="9%")
                  span(:title="$t('ui.withhold_bonus')") {{ $t("ui.withhold_bonus") }}
                th.text-right.sortable(width="9%")
                  span(:title="$t('ui.withhold_amount')") {{ $t("ui.withhold_amt") }}
                th.text-right.sortable(width="12%")
                  span(:title="$t('ui.max_withdraw_amount')") {{ $t("ui.max_withdraw_amt") }}
                th.text-right.sortable(width="12%")
                  span(:title="$t('ui.max_withdraw_multiple')") {{ $t("ui.max_withdraw_multiple") }}
                th(width="10%")
                  span(:title="$t('ui.provider_list')") {{ $t("ui.provider_list") }}
                th.text-center(width="5%")
                  span(:title="$t('ui.is_addon')") {{ $t("ui.is_addon") }}
                th.text-right.sortable(width="15%" @click="sortOrder('created_date')")
                  span {{ $t("ui.created_date") }}
                  i(:class="changeSortKey('created_date')")
            tbody.clusterize-content
              tr(v-if="campaignList.length == 0")
                td(colspan="13").text-center
                  span {{ $t('message.no_data_available') }}
              template(v-for="(item, index) in campaignList")
                tr(:class="$helpers.rowClassBit(item.status)")
                  td.text-center
                    span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                  td
                    template(v-if="isEditAccess")
                      span(:title="item.campaign_id")
                        a.text-primary.font-weight-bold.text-decoration-none(v-if="item.campaign_id" href="javascript:void(0)" @click="onEditCampaign(item)" :title="$t('ui.edit')") {{ item.campaign_id }}
                    template(v-else)
                      span.font-weight-bold(:title="item.campaign_id") {{ item.campaign_id }}
                  td
                    span(:title="item.campaign_name") {{ item.campaign_name }}
                  td
                    span(:title="item.criteria") {{ item.criteria }}
                  td.text-right
                    span(:title="item.rollover") {{ item.rollover }}
                  td.text-center
                    span
                      i(:class="{'fas fa-check text-info': item.withhold_bonus, 'fas fa-times text-warning': !item.withhold_bonus  }")
                  td.text-right
                    span(:title="$n(item.withhold_amount, 'currency')") {{ $n(item.withhold_amount, 'currency') }}
                  td.text-right
                    span(:title="$n(item.max_withdraw_amount, 'currency')") {{ $n(item.max_withdraw_amount, 'currency') }}
                  td.text-right
                    span(:title="$n(item.max_withdraw_multiple, 'currency')") {{ $n(item.max_withdraw_multiple, 'currency') }}
                  td
                    template(v-if="item.provider_list")
                      a.float-right.pointer(v-if="item.provider_list.split(',').map(p => p.trim()).length > 5" @click="onOffDetail(item)")
                        i.fa(:class="currId == item.campaign_id ? 'fa-minus' : 'fa-plus'")
                      b-badge.mr-1.mb-1(
                        v-for="(provider, i) in (item.provider_list.split(',').map(p => p.trim()).slice(0, 5))"
                        :key="provider"
                        variant="secondary"
                      )
                        | {{ provider }}
                    template(v-else)
                      b-badge {{ $t('ui.all') }}
                  td.text-center
                    span(:title="item.is_addon")
                      i(:class="{'fas fa-check text-info': item.is_addon, 'fas fa-times text-warning': !item.is_addon  }")
                  td.text-right
                    span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}
                tr(v-if="isShowDetail == true && currId == item.campaign_id")
                  td(colspan="15")
                    table.table.table-sm.table-bordered.table-striped.table-hover
                      thead.thead-dark
                        tr
                          th
                            span(:title="$t('ui.provider_list')") {{ $t("ui.provider_list") }}
                      tbody.clusterize-content
                        tr
                          td
                            template(v-if="item.provider_list")
                              b-badge.mr-1.mb-1(
                                v-for="(provider, i) in item.provider_list.split(',').map(p => p.trim())"
                                :key="provider"
                                variant="secondary"
                              )
                                | {{ provider }}

  addcampaign(@clicked="addCampaign" @failed="handleFailed")
  editcampaign(ref="editcampaign" :item="selectedCampaign"  @clicked="afterEditCampaign" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import addcampaign from "@/components/promo/addCampaign.vue";
import editcampaign from "@/components/promo/editCampaign.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    addcampaign,
    editcampaign
  },
  data: () => ({
    loading: false,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    currentPage: 1,
    totalRow: 0,
    sortKey: "campaign_id",
    sortType: "desc",
    search: "",
    campaignList: [],
    operatorList: [],
    selectedCampaign: null,
    currId: null,
    isShowDetail: false,
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSizeCampaign;
    },
    accountType() {
      return this.$store.getters.accountType;
    },
    isAdmin() {
      return this.$store.getters.accountType === 5;
    },
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    loginId() {
      return this.$store.getters.loginId;
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_campaign");
    }
  },
  mounted: function() { },
  methods: {
    onOffDetail(item) {
      if (this.isShowDetail == true) {
        if (this.currId == item.campaign_id) {
          this.isShowDetail = false;
          this.currId = null;
        } else {
          this.isShowDetail = false;
          this.currId = null;
          this.isShowDetail = true;
          this.currId = item.campaign_id;
        }
      } else {
        this.isShowDetail = true;
        this.currId = item.campaign_id;
      }
    },
    refresh() {
      this.getCampaignList()
    },
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }
      this.getCampaignList(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSizeCampaign", pageSize);
      this.currentPage = 1;
      this.getCampaignList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getCampaignList();
    },
    addCampaign: function() {
      this.search = "";
      this.getCampaignList(true);

      this.$helpers.showDialog(this.$t("ui.combine.add_campaign"), this.$t("message.success"), "success");
    },
    onEditCampaign: function(e) {
      this.selectedCampaign = e;
      this.$refs.editcampaign.$refs.editCampaign.show();
    },
    afterEditCampaign: function() {
      this.getCampaignList(true);
      this.$helpers.showDialog(this.$t("ui.combine.update_campaign"), this.$t("message.success"), "success");
    },
    getCampaignList: function(isSearch) {
      this.currId = null;
      this.isShowDetail = false;
      let url = config.campaignListUrl();

      if (isSearch) this.currentPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        sort_key: this.sortKey,
        sort_type: this.sortType,
        page_number: this.currentPage,
        page_size: this.getPageSize
      };

      if (this.search.trim() != '') {
        json.campaign_id = this.search.trim();
      }

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.campaignList = response.data.dt;
                this.totalRow = this.campaignList.length > 0 ? this.campaignList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>